import { type Either, isLeft } from 'fp-ts/lib/Either';
import { useState } from 'react';
import { useAuth } from './useAuth';
export interface SignInData {
  email: string;
  password: string;
}

export interface SignUpData extends SignInData {
  fullName: string;
  passwordRepeat: string;
}

export function useSubmitAuthForm() {
  const [, { signIn, signUp }] = useAuth();
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function submit<T extends 'signin' | 'signup'>(
    type: T,
    data: T extends 'signin' ? SignInData : SignUpData,
  ) {
    setSubmitting(true);
    setError('');

    let result: Either<
      unknown,
      {
        id: string;
        email: string;
        jwt: string;
      }
    >;

    if (type === 'signin') {
      result = await signIn(data.email, data.password);
    } else {
      const signUpData = data as SignUpData;
      result = await signUp(
        signUpData.email,
        signUpData.fullName,
        signUpData.password,
        signUpData.passwordRepeat,
      );
    }

    if (isLeft(result)) {
      const error = result.left;
      const errorMessage =
        typeof error === 'object' && error && 'message' in error
          ? String((error as { message: unknown }).message)
          : 'Something went wrong';

      setError(errorMessage);
    }

    setSubmitting(false);
    return result;
  }

  return { error, submitting, submit };
}
